import React, { useState, useEffect } from "react";
import { useGerminationTrayStore } from "Store/GerminationTrayStore";
import Modal from "react-modal";
import ModalStyle from "Assets/ModalStyle";

type Props = {
  trayId: string;
  setShowDeleteModal: (showDeleteModal: boolean) => void;
  showDeleteModal: boolean;
  redirectToTrays?: boolean;
};

const DeleteGerminationTrayModal = ({
  trayId,
  setShowDeleteModal,
  showDeleteModal,
  redirectToTrays,
}: Props) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteGerminationTray = useGerminationTrayStore(
    (state) => state.deleteGerminationTray,
  );

  const germinationTray = useGerminationTrayStore(
    (state) =>
      state.germinationTrays.find((tray) => tray._id === trayId) ??
      (state.currentGerminationTray?._id === trayId
        ? state.currentGerminationTray
        : undefined),
  );

  const handleDelete = async () => {
    setDeleting(true);
    if (!germinationTray?._id) return;
    try {
      await deleteGerminationTray(germinationTray?._id);
      if (redirectToTrays) {
        window.location.href = "/germinationTrays";
      } else {
        setShowDeleteModal(false);
      }
    } catch (error) {
      setError(`${error}`);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal
      style={ModalStyle.defaultStyle}
      ariaHideApp={false}
      isOpen={showDeleteModal}
    >
      <div className="m-50 p-5">
        <h3 className="text-lg py-5">Delete {germinationTray?.name}</h3>
        <p>Are you sure you want to delete {germinationTray?.name}?</p>
        <div className="flex pt-10">
          <button
            onClick={() => setShowDeleteModal(false)}
            className="btn bg-gray-light mr-5"
          >
            Cancel
          </button>
          <button
            onClick={() => void handleDelete()}
            className="btn btn-danger"
          >
            Delete
          </button>
        </div>
        {error && <p className="text-red-500">{error}</p>}
        {deleting && <p>Deleting...</p>}
      </div>
    </Modal>
  );
};

export default DeleteGerminationTrayModal;
